// Wave UX-2.1 Item 5 (2026-05-23) — 시세 가이드 카드.
// AuctionDetail 입찰 sticky 카드 위에 마운트.
// API: GET /buyer-app/auction/stats/sold-by-model?model=&days=30
// sealed envelope 유지 — 본인 입찰가 영향 없음 (집계 통계만).

import React, { useState, useEffect } from 'react';
import { API } from '../../utils/api';
import { authBuyerFetch } from './buyerApi';
import { useT, useLocale } from '../../i18n/I18nProvider';
import { formatKrwAmount, formatKrwAmountWithConvert, useExchangeRates } from '../../i18n/currency';

function StatsCard(props) {
  var model = props.model;
  var t = useT();
  var loc = useLocale();
  var rateState = useExchangeRates();
  var [data, setData] = useState(null);
  var [loaded, setLoaded] = useState(false);

  useEffect(function() {
    if (!model) { setLoaded(true); return; }
    var aborted = false;
    var url = API + '/buyer-app/auction/stats/sold-by-model?model=' + encodeURIComponent(model) + '&days=30';
    authBuyerFetch(url, {})
      .then(function(r){ return r.json(); })
      .then(function(d){
        if (aborted) return;
        if (d && d.success && d.data) setData(d.data);
        setLoaded(true);
      })
      .catch(function() { if (!aborted) setLoaded(true); });
    return function() { aborted = true; };
  }, [model]);

  if (!model) return null;

  // 로딩
  if (!loaded) {
    return (
      <div style={cardStyle}>
        <div style={{ fontSize: 11, fontWeight: 700, color: '#94a3b8', marginBottom: 4 }}>{t('statsCardTitle')}</div>
        <div style={{ fontSize: 12, color: '#94a3b8' }}>{t('statsCardLoading')}</div>
      </div>
    );
  }

  // 부족한 표본
  if (!data || data.code === 'INSUFFICIENT_SAMPLE') {
    return (
      <div style={cardStyle}>
        <div style={{ fontSize: 11, fontWeight: 700, color: '#94a3b8', marginBottom: 4 }}>{t('statsCardTitle')}</div>
        <div style={{ fontSize: 12, color: '#94a3b8' }}>{t('statsCardInsufficient')}</div>
      </div>
    );
  }

  return (
    <div style={cardStyle}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 8 }}>
        <span style={{ fontSize: 12, fontWeight: 800, color: '#0f172a' }}>{t('statsCardTitle')}</span>
        <span style={{ fontSize: 10, color: '#94a3b8' }}>{t('statsCardSampleSize', { count: data.count })}</span>
      </div>
      <div style={{ fontSize: 10, color: '#94a3b8', marginBottom: 12 }}>
        {t('statsCardSubtitle', { days: data.days })}
      </div>

      {/* 평균 — 강조 */}
      <div style={{ marginBottom: 10 }}>
        <div style={{ fontSize: 10, color: '#64748b', fontWeight: 600 }}>{t('statsCardAvg')}</div>
        <div style={{ fontSize: 18, fontWeight: 800, color: '#1B3A5C' }}>
          {formatKrwAmountWithConvert(data.avgPriceKrw, t, loc.locale, rateState.rates)}
        </div>
      </div>

      {/* 중간값 + 범위 */}
      <div style={{ display: 'flex', gap: 16 }}>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 10, color: '#64748b', fontWeight: 600 }}>{t('statsCardMedian')}</div>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#475569' }}>{formatKrwAmount(data.medianPriceKrw, t)}</div>
        </div>
        <div style={{ flex: 1.5 }}>
          <div style={{ fontSize: 10, color: '#64748b', fontWeight: 600 }}>{t('statsCardRange')}</div>
          <div style={{ fontSize: 12, fontWeight: 700, color: '#475569' }}>
            {formatKrwAmount(data.minPriceKrw, t)} ~ {formatKrwAmount(data.maxPriceKrw, t)}
          </div>
        </div>
      </div>
    </div>
  );
}

var cardStyle = {
  background: 'linear-gradient(135deg, #f8fafc 0%, #eff6ff 100%)',
  border: '1px solid #e2e8f0', borderRadius: 12,
  padding: 16, marginBottom: 12,};

export default StatsCard;
